export default {
    requisicoesServico: [],
    requisicaoServico: {},
    ultimaAtualizacaoLista: Date
}